import { getBlogPathSegments } from './getBlogArticleSection'

export function getBlogPageNumber(search: string): number {
  const page = new URLSearchParams(
    search.startsWith('?') ? search.slice(1) : search
  ).get('page')

  const parsed = Number.parseInt(page ?? '1', 10)

  return Number.isFinite(parsed) && parsed > 0 ? parsed : 1
}

export function isBlogCategoryPath(pathname: string): boolean {
  const segments = getBlogPathSegments(pathname)

  if (segments[0] !== 'blog' || segments.length !== 2) {
    return false
  }

  return segments[1] !== 'autor' && segments[1] !== '404'
}
